module.exports = __webpack_public_path__ + "static/img/bird9.341698d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bird9.png
// module id = XWag
// module chunks = 1